
const typeBackBtn = (() => {

  const pageType = (document.getElementById("pageType") != null);
  if (pageType) {

    {
      // let hostname = location.hostname;
      // console.log(hostname);

      // const ref = document.referrer
      // console.log(ref);
      // let jsBackBtn = document.getElementById('jsBackBtn')
      // //a要素のhref属性の値を取得する
      // let oldHref = jsBackBtn.getAttribute('href');
      // console.log(oldHref);

      // //a要素のhref属性の値を一部変更
      // let newHref;
      // if (hostname == 'localhost') {
      //   console.log("local");
      //   newHref = oldHref.replace('plan.php#ankPlan', 'limited/#ankPlan');
      // } else {
      //   newHref = oldHref.replace('plan.html#ankPlan', 'limited/#ankPlan');
      //   console.log("http");
      // }


      // // 遷移元がlimitedの時だけ実行したい処理
      // if (ref.indexOf('limited') !== -1) {
      //   //a要素のhref属性の値を一部変更
      //   jsBackBtn.setAttribute('href', newHref);
      // }
    }


    ////////////////////////////////


    {
      const href = location.href
      const ref = document.referrer
      let hrefCheck = href.includes('limited')
      let refCheck = ref.includes('limited')

      let jsBackBtn = document.getElementById('jsBackBtn')

      // 詳細ページ
      if (refCheck) {
        if (hrefCheck) {
          // 限定ページ
          console.log('exe limited');
          jsBackBtn.setAttribute('href', '../limited/#ankPlan');
        } else {
          // 通常ページ
          console.log('exe unlimited');
          jsBackBtn.setAttribute('href', './limited/#ankPlan');
        }
      }
    }


  }
})();
export default typeBackBtn;